import * as actionTypes from "../actions";
import {
  openFile,
  notifySuccess,
  notifyError,
} from "../../../components/Utils";
import { CONNECTION_TASK_TYPES } from "../components/Utils";

export const initialState = {
  adConnections: [],
  adWorkplaceTasks: [],
  ptConnections: [],
  delphiConnections: [],

  currentADConnectionType: "",
  currentADWorkplaceType: "",
  currentPTConnectionType: "",
  currentDelphiConnectionType: "",

  selectedADConnections: [],
  selectedADWorkplaceTasks: [],
  selectedPTConnections: [],
  selectedDelphiConnections: [],
};

export const initCurrentConnectionTypes = (state) => {
  const currentADConnectionType = state.currentADConnectionType !== '' ? state.currentADConnectionType : `${CONNECTION_TASK_TYPES.CREATE}-AD-CONNECTION`;
  const currentADWorkplaceType = state.currentADWorkplaceType !== '' ? state.currentADWorkplaceType : `${CONNECTION_TASK_TYPES.CREATE}-VBG-CONNECTION`;
  const currentPTConnectionType = state.currentPTConnectionType !== '' ? state.currentPTConnectionType : `${CONNECTION_TASK_TYPES.CREATE}-PT-CONNECTION`;
  const currentDelphiConnectionType = state.currentDelphiConnectionType !== '' ? state.currentDelphiConnectionType : `${CONNECTION_TASK_TYPES.CREATE}-DELPHI-CONNECTION`;
  return {
    currentADConnectionType,
    currentADWorkplaceType,
    currentPTConnectionType,
    currentDelphiConnectionType,
  };
};

const getTaskTitle = (connectionType) => {
  return connectionType === "VBG"
    ? "VBG-CSC Kennungen"
    : `${connectionType}-Zugänge`;
};

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    // filter connections
    case actionTypes.FILTER_CONNECTIONS: {
      // console.log(
      //   "REDUX REDUCER - filtering",
      //   action.connectionType,
      //   "connections by task",
      //   action.taskType,
      //   state.connections
      // );
      const { connectionType, taskType } = action;
      const key = connectionType === "VBG"
        ? "currentADWorkplaceType"
        : `current${connectionType}ConnectionType`;
      return {
        ...state,
        [key]: taskType,
      };
    }

    // setting selected connections
    case actionTypes.SET_SELECTED_AD_CONNECTION:
      return {
        ...state,
        selectedADConnections: action.selected,
      };
    case actionTypes.SET_SELECTED_AD_WORKPLACE_TASK:
      return {
        ...state,
        selectedADWorkplaceTasks: action.selected,
      };
    case actionTypes.SET_SELECTED_PT_CONNECTION:
      return {
        ...state,
        selectedPTConnections: action.selected,
      };
    case actionTypes.SET_SELECTED_DEPLPHI_CONNECTION:
      return {
        ...state,
        selectedDelphiConnections: action.selected,
      };

    // export AD-Connections, PT Connections, Delphi-Connections as CSV
    case actionTypes.EXPORT_ADCONNECTIONS:
    case actionTypes.EXPORT_PTCONNECTIONS:
    case actionTypes.EXPORT_DELPHICONNECTIONS:
    case actionTypes.EXPORT_ADWORKPLACE_TASKS:
      return {
        ...state,
        loading: true,
      };
    case actionTypes.EXPORT_ADCONNECTIONS_SUCCESS:
    case actionTypes.EXPORT_PTCONNECTIONS_SUCCESS:
    case actionTypes.EXPORT_DELPHICONNECTIONS_SUCCESS:
    case actionTypes.EXPORT_ADWORKPLACE_TASKS_SUCCESS: {
      const title = getTaskTitle(action.connectionType);
      openFile(action.result.filePath);
      notifySuccess({
        summary: `${title} exportieren`,
        detail: `Die gewählte ${title} wurden erfolgreich exportiert.`,
      });
      const listName = action.connectionType === "VBG"
        ? "selectedADWorkplaceTasks"
        : `selected${action.connectionType}Connections`;
      return {
        ...state,
        loading: false,
        [listName]: [],
      };
    }
    case actionTypes.EXPORT_ADCONNECTIONS_FAILURE:
    case actionTypes.EXPORT_PTCONNECTIONS_FAILURE:
    case actionTypes.EXPORT_DELPHICONNECTIONS_FAILURE:
    case actionTypes.EXPORT_ADWORKPLACE_TASKS_FAILURE: {
      const title = getTaskTitle(action.connectionType);
      notifyError({
        summary: `${title} exportieren`,
        detail: `Die gewählte ${title} konnten nicht exportiert werden.`,
      });
      return {
        ...state,
        loading: false,
        error: action.result,
      };
    }

    // close connection task
    case actionTypes.CLOSE_CONNECTION_TASK:
      return {
        ...state,
        loading: true,
      };
    case actionTypes.CLOSE_CONNECTION_TASK_SUCCESS: {
      const title = getTaskTitle(action.connectionType);
      notifySuccess({
        summary: `${title} abschliessen`,
        detail: `Der gewählte ${title} wurde erfolgreich abgeschlossen.`,
      });
      return {
        ...state,
        loading: false,
      };
    }
    case actionTypes.CLOSE_CONNECTION_TASK_FAILURE: {
      const title = getTaskTitle(action.connectionType);
      notifyError({
        summary: `${title} abschliessen`,
        detail: `Der gewählte ${title} konnte nicht abgeschlossen werden.`,
      });
      return {
        ...state,
        loading: false,
        error: action.result,
      };
    }

    // close ad-workplace tasks
    case actionTypes.CLOSE_ADWORKPLACE_TASKS:
      return {
        ...state,
        loading: true,
      };
    case actionTypes.CLOSE_ADWORKPLACE_TASKS_SUCCESS: {
      notifySuccess({
        summary: `VBG-CSC Kennungen schliessen`,
        detail: `Der gewählte VBG-CSC Kennungen wurden erfolgreich geschlossen.`,
      });
      return {
        ...state,
        loading: false,
      };
    }
    case actionTypes.CLOSE_CONNECTION_TASK_FAILURE: {
      notifyError({
        summary: `VBG-CSC Kennungen schliessen`,
        detail: `Der gewählte VBG-CSC Kennungen konnte nicht abgeschlossen werden.`,
      });
      return {
        ...state,
        loading: false,
        error: action.result,
      };
    }

    // delete connection task
    case actionTypes.DELETE_CONNECTION_TASK:
      return {
        ...state,
        loading: true,
      };
    case actionTypes.DELETE_CONNECTION_TASK_SUCCESS:
      notifySuccess({
        summary: `${action.connectionType}-Zugangsaufgabe löschen`,
        detail: `Der gewählte ${action.connectionType}-Zugangsaufgabe wurde erfolgreich gelöscht.`,
      });
      return {
        ...state,
        loading: false,
      };
    case actionTypes.DELETE_CONNECTION_TASK_FAILURE:
      notifyError({
        summary: `${action.connectionType}-Zugang löschen`,
        detail: `Die gewählte ${action.connectionType}-Zugangsaufgabe konnte nicht gelöscht werden.`,
      });
      return {
        ...state,
        loading: false,
        error: action.result,
      };

    default:
      return null;
  }
};
